module.exports = "pegasus/assets/theme3/medium/6.jpg";